import { render, staticRenderFns } from "./PengajuanIjinAllStaff.vue?vue&type=template&id=928aaf40&scoped=true"
import script from "./PengajuanIjinAllStaff.vue?vue&type=script&lang=js"
export * from "./PengajuanIjinAllStaff.vue?vue&type=script&lang=js"
import style0 from "./PengajuanIjinAllStaff.vue?vue&type=style&index=0&id=928aaf40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928aaf40",
  null
  
)

export default component.exports